module.exports = __webpack_public_path__ + "static/media/Attention.41eb4f23.svg";